import { Fragment, useEffect, useState } from 'react';
import { Navbar } from '../../components/Navbar';

import FarmshareBG from '../../assets/FarmshareBG.jpg';
import { DetailEquipment } from '../../components/DetailEquipment';

import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom';
import { getSingleEquipment, getEquipmentContact } from '../../redux/slices/equipmentsSlice';
import { CreateReservationModal } from '../../components/CreateReservationModal';
import { ROUTES } from '../../constants/routes';

const DetailEquipmentPage = () => {
  const { equipmentId } = useParams();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const equipment = useSelector((state) => state.equipments.selectedEquipment);
  const contact = useSelector((state) => state.equipments.ownerContact);
  const [showCreateReservationModal, setShowCreateReservationModal] = useState(false);
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    dispatch(getSingleEquipment(equipmentId));
    dispatch(getEquipmentContact(equipmentId));
  }, [equipmentId, dispatch]);

  return (
    <Fragment>
      {!equipment ? (
        <Navigate to={ROUTES.FARM_SHARE} />
      ) : (
        <div className="mb-8">
          <Navbar src={FarmshareBG} pageName={`Farmshare`} />
          <DetailEquipment
            equip={equipment}
            contact={contact}
            showResModal={setShowCreateReservationModal}
            setQuantity={setQuantity}
            quantity={quantity}
          />
          {showCreateReservationModal && equipment && equipment._id && (
            <CreateReservationModal
              setShowCreateReservationModal={setShowCreateReservationModal}
              userId={user._id}
              renterName={user.firstName + ' ' + user.lastName}
              equipment={equipment}
              quantity={quantity}
            />
          )}
        </div>
      )}
    </Fragment>
  );
};

export { DetailEquipmentPage };
